/** Local imports */
import {reducer as galleryData} from './galleryData';
import {reducer as favorites} from './favorites';
import {reducer as filters} from './filters';
import {reducer as cachedGalleryImg} from './cachedGalleryImg';

export const rootReducer = {
  galleryData,
  favorites,
  filters,
  cachedGalleryImg,
};
